import React, { useState } from 'react';
import axios from 'axios';
import { BackendURL } from '../utils/BackendURL';
import AllOrders from '../MyComponents/AllOrders';

const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showPasswordPrompt, setShowPasswordPrompt] = useState(true);

  const onFileChange = (e) => {
    setFile(e.target.files[0]);
    const fileInput = e.target;
    const fileName = fileInput.files.length > 0 ? fileInput.files[0].name : 'No File Chosen';
    const fileNameSpan = document.getElementById('file-name');
    fileNameSpan.textContent = fileName;
  };

  const onFileUpload = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(`${BackendURL}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      setMessage('File uploaded successfully');
      console.log(response.data);
    } catch (error) {
      setMessage('Failed to upload file');
      console.error(error);
    }
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === 'mdpharmacy123') {
      setIsAuthenticated(true);
      setShowPasswordPrompt(false);
      setMessage('')
    } else {
      setMessage('Incorrect password');
    }
  };

  return (
    <>
      <div className="upload-body">
        {showPasswordPrompt && !isAuthenticated ? (
          <div className="password-prompt">
            <h2 className="password-title">Enter Password</h2>
            <form className="password-form" onSubmit={handlePasswordSubmit}>
              <input
                type="password"
                className="password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
              />
              <button type="submit" className="password-submit-button">Submit</button>
            </form>
            <p className="upload-message">{message}</p>
          </div>
        ) : (
          <div className='admin-panel'>
            <div className="admin-panel-name">
              Admin Panel
            </div>
            <div className="upload-container">
              <h2 className="upload-header">UPDATE FILE</h2>
              <form className="upload-form" onSubmit={onFileUpload}>
                <div className="file-upload-div">
                  <input type="file" id="file-upload" className="upload-input" onChange={onFileChange} />
                  <label htmlFor="file-upload" className="upload-label">
                    <div className="upload-text">Choose a file</div>
                  </label>
                  <div className='file-name-div' id="file-name">No File Chosen</div>
                </div>
                <button type="submit" className="upload-button">UPDATE</button>
              </form>
              <p className="upload-message">{message}</p>
            </div>
            <AllOrders />
          </div>
        )}
      </div>
    </>
  );
};

export default FileUpload;


